import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  return (
    <main className="pt-16 min-h-screen">
      <BrandIntro />
      <Reputation />
      <ContactSection />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于蘑菇视频',
          description: '蘑菇视频是领先的高清视频平台，成立于2018年，提供海量正版高清视频内容。了解蘑菇视频的品牌故事、用户口碑和联系方式。',
          url: 'https://www.moguvideo.com/about',
          mainEntity: {
            '@type': 'Organization',
            name: '蘑菇视频',
            foundingDate: '2018',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-400-888-9999',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          },
        })}
      </script>
    </main>
  );
}